import { FormEvent, useState } from "react";

import { Feedback } from "@/api/models";

interface UnhelpfulFeedbackContentProps {
  negativeFeedbackList: Feedback[];
  updateFeedbackList: (ev?: FormEvent<HTMLElement | HTMLInputElement>) => void;
  setShowReportInappropriateFeedback: (val: boolean) => void;
  otherFeedbackText: string;
  setOtherFeedbackText: (text: string) => void;
}

const UnhelpfulFeedbackContent = ({ negativeFeedbackList, updateFeedbackList, setShowReportInappropriateFeedback, otherFeedbackText, setOtherFeedbackText }: UnhelpfulFeedbackContentProps) => {
  const isOtherChecked = negativeFeedbackList.includes(Feedback.OtherUnhelpful);
  const handleOtherCheckboxChange = (ev: FormEvent<HTMLInputElement>) => {
    updateFeedbackList(ev);
    // Clear the text field when unchecking
    if (!(ev.target as HTMLInputElement).checked) {
      setOtherFeedbackText('');
    }
  };
  return (<>
    <div>Why wasn't this response helpful?</div>
    <div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.MissingCitation} defaultChecked={negativeFeedbackList.includes(Feedback.MissingCitation)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Citations are missing</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.WrongCitation} defaultChecked={negativeFeedbackList.includes(Feedback.WrongCitation)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Citations are wrong</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.OutOfScope} defaultChecked={negativeFeedbackList.includes(Feedback.OutOfScope)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">The response is not from my data</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.InaccurateOrIrrelevant} defaultChecked={negativeFeedbackList.includes(Feedback.InaccurateOrIrrelevant)} onChange={updateFeedbackList} />
          <span className="label-text ms-3">Inaccurate or irrelevant</span>
        </label>
      </div>
      <div className="form-control">
        <label className="cursor-pointer label justify-start">
          <input type="checkbox" className="checkbox checkbox-sm" id={Feedback.OtherUnhelpful} defaultChecked={negativeFeedbackList.includes(Feedback.OtherUnhelpful)} onChange={handleOtherCheckboxChange} />
          <span className="label-text ms-3">Other</span>
        </label>
      </div>
      {isOtherChecked && (
        <div className="form-control mt-2 ms-8">
          <input 
            type="text" 
            placeholder="Please specify" 
            className="input input-sm input-bordered w-full max-w-md"
            maxLength={128}
            value={otherFeedbackText}
            onChange={(e) => setOtherFeedbackText(e.target.value)}
          />
        </div>
      )}
      <div className="text-sm cursor-pointer my-3" style={{color:"#0076bf"}} onClick={() => setShowReportInappropriateFeedback(true)}>Report inappropriate content</div>
    </div>
  </>);
}

export default UnhelpfulFeedbackContent;